import React from 'react';

import 'css/components/www/_Quotes.scss';

type Props = {
  children: React.ReactNode;
  title: React.ReactNode | string;
};
const Quotes = ({ children, title }: Props) => {
  return (
    <section className="quotesSection">
      <h2 className="quoteHeader">{title}</h2>
      <div className="quotes">{children}</div>
    </section>
  );
};

export default Quotes;
